


$(document).ready(function () {


    document.querySelectorAll('[data-slider-config]').forEach(slider => {
      const config = JSON.parse(slider.dataset.sliderConfig);

      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(config);
      }
    });

});

 $(document).on("click", ".hk-play-button", function (e) {
     var video = jQuery(this).parents('.hk-video-wrapper').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.hk-video-wrapper').removeClass('active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.hk-video-wrapper').addClass('active');
     jQuery(this).addClass('active');
 }
 });



 
jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

$(window).on('scroll', function () {
  let scrollTop = $(this).scrollTop();

  if (scrollTop > 30) {
    $('body').addClass('remove_transparent');
  } else {
    $('body').removeClass('remove_transparent');
  }
});

$(document).on("click", ".hk-mega-menu-toggle", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.hk-mega-menu-toggle').removeClass('active');
    jQuery('.hk-mega-menu-toggle').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});


$(document).on("click", ".hk-question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.hk-question').removeClass('active');
    jQuery('.hk-question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});


$(document).on("click", "a[href='/#faq']", function (e) {
  const target = document.querySelector('.hk-faq');

  if (target) {
    e.preventDefault();
    target.scrollIntoView({
      behavior: 'smooth'
    });
  }
  // else: do nothing → browser follows the link normally
});
$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", ".hk-mobile-menu-button", function (e) {
    $('.hk-drawer-menu').addClass('active');
    $('.hk-drawer-menu-bg').show();
    $('body').addClass('hk-overflow-hidden');
});
$(document).on("click", ".hk-mobile-menu-close", function (e) {
    $('.hk-drawer-menu').removeClass('active');
    $('.hk-drawer-menu-bg').hide();
    $('body').removeClass('hk-overflow-hidden');
});

$(document).on("click", ".hk-drawer-menu-bg", function (e) {
    $('.hk-drawer-menu').removeClass('active');
    $('.hk-drawer-menu-bg').hide();
    $('body').removeClass('hk-overflow-hidden');
});




$(document).on("click", ".hk-element-option", function(e) {
$(this).parents('.hk-product').find('.hk-element-option').removeClass('active');
$(this).addClass('active');
var data_tab = $(this).attr('data_tab');
$(this).parents('.hk-product').find('.hk-quantity-data').hide();
$(this).parents('.hk-product').find('.hk-quantity-data[data_tab="'+data_tab+'"]').show();
});


$(document).on("click", ".hk-sub-toggle.active", function(e) {
$(this).removeClass('active');
var sub_tab = 1;
$(this).parents('.hk-product').find('.hk-sub-tab').hide();
$(this).parents('.hk-product').find('.hk-sub-tab[sub_tab="'+sub_tab+'"]').show();
});

$(document).on("click", ".hk-sub-toggle:not(.active)", function(e) {
$(this).addClass('active');
var sub_tab = 2;
$(this).parents('.hk-product').find('.hk-sub-tab').hide();
$(this).parents('.hk-product').find('.hk-sub-tab[sub_tab="'+sub_tab+'"]').show();
});











$(document).on("click", ".hk-cart-button", function (e) {
  e.preventDefault();
    $('.hk-cart-drawer').addClass('active');
    $('.hk-drawer-cart-bg').show();
    $('body').addClass('hk-overflow-hidden');
});
$(document).on("click", ".hk-mobile-cart-close, .hk-drawer-cart-bg, a[href='#close_cart']", function (e) {
  e.preventDefault();
    $('.hk-cart-drawer').removeClass('active');
    $('.hk-drawer-cart-bg').hide();
    $('body').removeClass('hk-overflow-hidden');
});














function refreshCartDrawer() {
  $.get(window.location.href, function (response) {
    var newContent = $(response).find('.hk-cart-drawer-js').html();
    $('.hk-cart-drawer-js').html(newContent);
    $('.hk-cart-drawer-js').removeClass('hk-loading-cart');
    updateCartCount();
    
    document.querySelectorAll('.hk-element-related-grid.hk-slick-slider[data-slider-config]').forEach(slider => {
      const config = JSON.parse(slider.dataset.sliderConfig);

      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(config);
      }
    });

    updateBundleSellingPlans();
    updateBundleVariants();
  });
  
}

function updateCartCount() {
  return fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      var count = 0;
      cart.items.forEach(function (item) {
          count += item.quantity;
      });
      $('.hk-cart-count').text(count);
      if (count > 0) {
        $('.hk-cart-count').show();
      } else {
        $('.hk-cart-count').hide();
      }
      return count;
    })
    .catch(err => console.error('Cart count error:', err));
}

$(document).on('click', '.hk-cart-drawer-js .hk-quantity-plus, .hk-cart-drawer-js .hk-quantity-minus', function () {
    $('.hk-cart-drawer-js').addClass('hk-loading-cart');
  var $btn = $(this);
  var $wrapper = $btn.closest('.hk-line-item');
  var $input = $wrapper.find('.hk-quantity-input');

  var key = $wrapper.data('key');
  var qty = parseInt($input.val());

  if ($btn.hasClass('hk-quantity-plus')) {
    qty++;
  } else {
    qty--;
  }

  // update UI instantly
  $input.val(qty);

  // Shopify AJAX cart update
  $.ajax({
    url: '/cart/change.js',
    type: 'POST',
    data: {
      id: key,
      quantity: qty
    },
    dataType: 'json',
    success: function (cart) {
        refreshCartDrawer();
    },
    error: function (err) {
      console.error('Cart update failed', err);
    }
  });
});




// remove item completely
$(document).on('click', '.hk-cart-drawer-js .hk-quantity-remove', function () {

  $('.hk-cart-drawer-js').addClass('hk-loading-cart');

  var $wrapper = $(this).closest('.hk-line-item');
  var key = $wrapper.data('key');

  $.ajax({
    url: '/cart/change.js',
    type: 'POST',
    data: {
      id: key,
      quantity: 0
    },
    dataType: 'json',
    success: function (cart) {
      refreshCartDrawer();
    },
    error: function (err) {
      console.error('Remove failed', err);
      $('.hk-cart-drawer-js').removeClass('hk-loading-cart');
    }
  });

});




$(document).on("click", '.hk-atc-js', function (e) {
  e.preventDefault();
  var $btn = $(this).addClass('hk-loading');
  var items = [];
  var variant_id =  $(this).attr('variant_id');
  var Item = {
    id: parseInt(variant_id),
    quantity: 1
  };
  items.push(Item);
  // Single call to /cart/add.js
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify({ items: items }),
    dataType: 'json',
    contentType: 'application/json',
    success: function () {
    },
    complete: function () {
      setTimeout(function () {
        $btn.removeClass('hk-loading');
      refreshCartDrawer();
    $('.hk-cart-drawer').addClass('active');
    $('.hk-drawer-cart-bg').show();
    $('body').addClass('hk-overflow-hidden');
      }, 500);
    }
  });
});





function updateBundleSellingPlans() {
  const defaultVariantConfigs = {
    52298605986066: {
      1: 694951969042,
      2: 694952100114,
      3: 694952132882,
      '3+': 694952165650
    },
    52290710962450: {
      1: 694951969042,
      2: 694952100114,
      3: 694952132882,
      '3+': 694952165650
    }
  };

  const usVariantConfigs = {
    52298605986066: {
      1: 694951969042,
      2: 694960193810,
      3: 694960226578,
      '3+': 694960259346
    },
    52290710962450: {
      1: 694951969042,
      2: 694960193810,
      3: 694960226578,
      '3+': 694960259346
    }
  };

  const variantConfigs =
    Shopify.country === 'US'
      ? usVariantConfigs
      : defaultVariantConfigs;

  $.getJSON('/cart.js', function(cart) {

    const updates = [];

    cart.items.forEach(function(item) {

      const variantId = item.variant_id;

      if (!variantConfigs[variantId]) return;
  // Skip one-time purchases
  if (!item.selling_plan_allocation) return;

      const qty = item.quantity;

      let correctSellingPlan;

      if (qty >= 4) {
        correctSellingPlan = variantConfigs[variantId]['3+'];
      } else {
        correctSellingPlan = variantConfigs[variantId][qty];
      }

      const currentSellingPlan = item.selling_plan_allocation
        ? item.selling_plan_allocation.selling_plan.id
        : null;

      if (String(currentSellingPlan) !== String(correctSellingPlan)) {
        updates.push({
          id: item.key,
          quantity: qty,
          selling_plan: correctSellingPlan
        });
      }
    });

    if (!updates.length) return;
  $('.hk-cart-drawer-js').addClass('hk-loading-cart');

    const requests = updates.map(update => {
      return $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          id: update.id,
          quantity: update.quantity,
          selling_plan: update.selling_plan
        },
        dataType: 'json'
      });
    });

    Promise.all(requests).then(function() {
      refreshCartDrawer();
    });

  });
}



function updateBundleVariants() {

  const groups = [
    {
      variants: [
        52298605986066,
        52298606510354,
        52298606575890,
        52298606608658
      ],
      mapping: {
        1: 52298605986066,
        2: 52298606510354,
        3: 52298606575890,
        '3+': 52298606608658
      }
    },
    {
      variants: [
        52290710962450,
        52290714730770,
        52290715287826,
        52290715320594
      ],
      mapping: {
        1: 52290710962450,
        2: 52290714730770,
        3: 52290715287826,
        '3+': 52290715320594
      }
    }
  ];

  $.getJSON('/cart.js', function(cart) {

    const requests = [];

    cart.items.forEach(function(item) {

      const group = groups.find(g =>
        g.variants.includes(item.variant_id)
      );

      if (!group) return;
  // Skip one-time purchases
  if (item.selling_plan_allocation) return;

      const qty = item.quantity;

      const targetVariant =
        qty >= 4
          ? group.mapping['3+']
          : group.mapping[qty];

      if (item.variant_id == targetVariant) return;
  $('.hk-cart-drawer-js').addClass('hk-loading-cart');

      requests.push(
        $.post('/cart/change.js', {
          id: item.key,
          quantity: 0
        }).then(function() {
          return $.post('/cart/add.js', {
            id: targetVariant,
            quantity: qty
          });
        })
      );

    });

    if (requests.length) {
      Promise.all(requests).then(function() {
        refreshCartDrawer();
      });
    }

  });

}



 
jQuery(document).ready(function() {
    var shipping_price = $('.hk-free-ship-bar').attr('shipping_price');

    $('.hk-header-text1 p').html(function(_, text) {
        return text.replace('[shipping_price]', shipping_price);
    });
});